export const isDebugMode = () => location.hash === '#debug'
